import {call, put, takeLatest} from 'redux-saga/effects';
import {base_url, endpoints} from '../../../constants';
import {AxiosService} from '../../../services';
import {actionTypes} from '../../../types';
import {getMyBrandBusinessDetailFailure, getMyBrandBusinessDetailSuccess} from "../../actions/BrandBusinessActions/getMyBrandBusinessDetailActions";

function* getMyBrandBusinessDetail({ callback }) {
    try {
        const response = yield call(AxiosService, {
            method: 'get',
            base_url: base_url,
            endPoint: endpoints.getMyBrandBusinessDetail,
            isAuth: true,
        });
        console.log('====================================');
        console.log("GET_MY_BRAND_BUSINESS_SUCCESS status :", response.data.status);
        console.log("GET_MY_BRAND_BUSINESS_SUCCESS data :", response.data.response);
        console.log("GET_MY_BRAND_BUSINESS_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            getMyBrandBusinessDetailSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        if (callback) {
            callback(
                response?.data?.status,
                response?.data?.response,
                response?.data?.message
            ); // Pass the response data to the callback
        }
    } catch (error) {
        console.log('====================================');
        console.log("GET_MY_BRAND_BUSINESS_FAILURE status :", error?.response?.status);
        console.log("GET_MY_BRAND_BUSINESS_FAILURE data:", error?.response?.data);
        console.log("GET_MY_BRAND_BUSINESS_FAILURE error :", error);
        console.log('====================================');
        yield put(getMyBrandBusinessDetailFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* getMyBrandBusinessDetailSaga() {
    yield takeLatest(actionTypes.GET_MY_BRAND_BUSINESS_REQUEST, getMyBrandBusinessDetail);
}

export default getMyBrandBusinessDetailSaga;
